import React from 'react'
import { useOutletContext } from 'react-router-dom'; // Importante

function Help() {

  const { user } = useOutletContext();

  return (
    <>
      {user.role === 'tecnico' ?
        // PÚBLICO/TÉCNICOS
        <div className='w-full h-full'>
          <iframe className='w-full h-full' src='https://vimeo.com/showcase/11544963/embed2' allowfullscreen='true' frameborder='0'>
          </iframe>
        </div>
        :
        // PRIVADO
        <div className='w-full h-full'>
          <iframe className='w-full h-full' src='https://vimeo.com/showcase/11546132/embed2' allowfullscreen='true'>
          </iframe>
        </div>
      }
    </>
  )
}

export default Help